import React from 'react';
import IconBadge from './IconBadge';
import { IconName } from './icons';

export type IconRowItem = {
  icon: IconName;
  title: string;
  body: string;
};

type IconRowProps = {
  items: IconRowItem[];
  /** onDark: white disc with teal icon, white label, mint line (deep-teal and night bands). */
  tone?: 'onLight' | 'onDark';
  className?: string;
};

/** Teal disc, bold label, one short line. Three across from 768 px, stacked on phones. */
const IconRow: React.FC<IconRowProps> = ({ items, tone = 'onLight', className }) => {
  const classes = ['ui-icon-row'];
  if (tone === 'onDark') classes.push('ui-icon-row--on-dark');
  if (className) classes.push(className);
  return (
    <ul className={classes.join(' ')}>
      {items.map((item) => (
        <li key={item.title} className="ui-icon-row__item">
          <IconBadge name={item.icon} tone={tone === 'onDark' ? 'inverse' : 'teal'} />
          <div className="min-w-0">
            <p className="ui-icon-row__title">{item.title}</p>
            <p className="ui-icon-row__body">{item.body}</p>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default IconRow;
